__turbopack_context__.v({
  "mainNumber": "CardIconMore-module-scss-module__4_KB-q__mainNumber",
  "root": "CardIconMore-module-scss-module__4_KB-q__root",
});
